import React from 'react';

import Chip from '../../CoreWrappers/Chip';

import StyledChip from './StyledChip';

const ColoredChip = ({containerClassName, ...otherProps}) => (
	<StyledChip className={containerClassName}>
		<Chip {...otherProps} />
	</StyledChip>
);

export default ColoredChip;
